import { createFileRoute } from '@tanstack/react-router'
import { FolderTree } from 'lucide-react'
import { z } from 'zod'
import { NamespacesScreen } from '@/screens/workspace/SCR-005-namespaces'

export const Route = createFileRoute('/_app/w/$ws/namespaces')({
  staticData: { screen: {"id":"SCR-005","title":"Namespaces","group":"Workspace","perm":["namespace.manage","memory.read"],"order":5,"description":"Where memory lives: sessions, agents, projects, people and the organisation.", icon: FolderTree } },
  validateSearch: z.object({
    kind: z.enum(['session', 'agent', 'project', 'user', 'enterprise']).optional(),
    status: z.enum(['active', 'archived']).optional(),
    n: z.string().max(200).optional(),
  }),
  component: NamespacesScreen,
})
